export default {
    install(Vue) {
        Vue.prototype.$user = window.user;
    },
};